<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <br />
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
let self = {};
export default {
  name: "TableClbResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.TENCENT.CLB.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.TENCENT.CLB.loadBalancerId"),
          key: "loadBalancerId"
        },
        {
          title: this.$t("RAM.TENCENT.CLB.name"),
          key: "name"
        },
        {
          title: this.$t("RAM.TENCENT.CLB.region"),
          key: "regionName"
        },
        {
          title: this.$t("RAM.TENCENT.CLB.vip"),
          key: "vip"
        },
        {
          title: this.$t("RAM.TENCENT.CLB.statusName"),
          key: "statusName"
        },
        {
          title: this.$t("RAM.TENCENT.CLB.type"),
          key: "type"
        },
        {
          title: this.$t("RAM.TENCENT.CLB.createdTime"),
          key: "createdTime"
        }
      ],
      tableData: []
    };
  },
  created() {
    this._handleCompanyId = val => { this.companyId = val; };
    this._handleAccountSearchKey = val => { this.accountSearchKey = val; };
    this._handleAccountName = val => { this.accountName = val; };
    eventBus.$on("companyId", this._handleCompanyId);
    eventBus.$on("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$on("accountName", this._handleAccountName);
    self = this;
  },
  methods: {
    showAll() {
      self.current = 1;
      self.getData();
    },
    getData() {
      self.$api.resourceManagement
        .selectTencentClbByPage({
          companyId: self.companyId,
          accountName: self.accountName,
          accountIdList: self.accountSearchKey,
          pageNum: self.current,
          pageSize: self.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          this.current = res.data.current;
          this.dataTotal = res.data.total;
        });
    },
    changePage(current) {
      this.current = current;
      this.getData();
    },
    changeSize(pageSize) {
      this.pageSize = pageSize;
      this.getData();
    }
  },
  beforeDestroy() {
    eventBus.$off("companyId", this._handleCompanyId);
    eventBus.$off("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$off("accountName", this._handleAccountName);
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/tencent/clb/TableClbResource.vue